import { createFileRoute } from '@tanstack/react-router';

import { CreditsScreen } from '@/screens/settings/CreditsScreen';

export const Route = createFileRoute('/_app/settings/credits')({
  component: CreditsScreen,
});
